export default __webpack_public_path__ + "static/preview-61bbc188a55e42deb51fc7c2d113b399.png";